import { render, staticRenderFns } from "./TabletFeaturedCard.vue?vue&type=template&id=4c4fd6c8&"
import script from "./TabletFeaturedCard.vue?vue&type=script&lang=js&"
export * from "./TabletFeaturedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports